import { Accommodation } from './../../../shared/models/accommodation.model';
import { DVFormArray, DVFormGroup, DVFormControl } from './../../../shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { AccommodationService } from './../../services/accommodation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class CreateComponent implements OnInit {
  currentId = undefined;
  accommodation = new Accommodation();
  accommodationForm: DVFormGroup;
  RoomTypes: DVFormGroup;
  isAddState = true;
  countries: any = [];
  cities: any = [];
  locals: any = [];
  Location: DVFormGroup;
  // @ts-ignore
  range = _.range;
  isHotel = false;

  constructor(
    public route: ActivatedRoute,
    private accommodationService: AccommodationService,
    private notifier: SnotifyService,
    private router: Router
  ) {

    this.accommodationForm = new DVFormGroup({
      name: new DVFormControl(null, {
        'Name is required': Validators.required
      }),
      badge: new DVFormControl(null, {
        'Badge is required': Validators.required
      }),
      description: new DVFormControl(null, {
        'Description is required': Validators.required
      }),
      type: new DVFormControl(null, {
        'Accommodation type is required': Validators.required
      }),
      included: new DVFormControl([], {
        'Included is required': Validators.required
      }),
      cityId: new DVFormControl(null, {
        'City is required': Validators.required
      }),
      localId: new DVFormControl(null, {
        'Local is required': Validators.required
      }),
      Location: new DVFormControl({}, {
        'Location is required': Validators.required
      }),
      RoomTypes: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'capacity',
            type: 'CONTROL',
            default: 0,
            validators: {
              'Capacity is required': Validators.required
            }
          },
          {
            name: 'name',
            type: 'CONTROL',
            default: null,
            validators: {
              'Name is required': Validators.required
            }
          },
          {
            name: 'pricePerPerson',
            type: 'CONTROL',
            default: 0,
            validators: {
              'Price is required': Validators.required
            }
          }
        ],
        0,
        {
          'RoomTypes are required': Validators.required
        }
      ),
      AccommodationPictures: new DVFormControl([], {
        'Accommodation Pictures are required': Validators.required
      }),
      childrenPolicy: new DVFormControl(''),
      facilities: new DVFormControl([])
    });
  }

  ngOnInit() {
    this.currentId = this.route.snapshot.params.id;

    if (this.currentId) {
      this.isAddState = false;
      this.loadAccommodation();
    }
    this.loadCities();
    this.loadLocals();

    this.onChanges();
  }

  SubmitForm() {
    if (this.accommodationForm.invalid) {
      this.accommodationForm.forceShowErrors();
      return;
    }

    this.getFormData();

    this.accommodationService.createAccommodation(this.accommodation).subscribe(res => {
      this.notifier.success('Accommodation Added Successfully');
      this.router.navigateByUrl('/accommodations/list');
    },
      err => {
        this.notifier.error(err.error.userMessage);
      });
  }

  onChanges(): void {
    this.accommodationForm.get('type').valueChanges.subscribe(val => {
      const childrenPolicyControl = this.accommodationForm.get('childrenPolicy') as DVFormControl;
      const facilitiesControl = this.accommodationForm.get('facilities') as DVFormControl;

      if (val === AccommodationType.Hotel) {
        this.isHotel = true;

        childrenPolicyControl.addValidators({
          'Children Policy is required': Validators.required
        });
        facilitiesControl.addValidators({
          'Facilities is required': Validators.required
        });
      } else {
        this.isHotel = false;
        this.accommodationForm.controls.childrenPolicy.setValue('');
        childrenPolicyControl.setValidators(null);
        this.accommodationForm.controls.facilities.setValue([]);
        facilitiesControl.setValidators(null);
      }
      childrenPolicyControl.updateValueAndValidity();
      facilitiesControl.updateValueAndValidity();
    });
  }

  getFormData() {
    this.accommodation.name = this.accommodationForm.value.name;
    this.accommodation.badge = this.accommodationForm.value.badge;
    this.accommodation.description = this.accommodationForm.value.description;
    this.accommodation.type = this.accommodationForm.value.type;
    this.accommodation.included = this.accommodationForm.value.included;
    this.accommodation.localId = this.accommodationForm.value.localId;

    delete this.accommodationForm.value.Location.createdAt;
    delete this.accommodationForm.value.Location.updatedAt;
    this.accommodation.Location = this.accommodationForm.value.Location;

    this.accommodation.childrenPolicy = this.accommodationForm.value.childrenPolicy;
    this.accommodation.AccommodationPictures = this.accommodationForm.value.AccommodationPictures;

    if (!this.currentId) {
      this.accommodationForm.value.RoomTypes.forEach(element => {
        delete element.id;
      });
    }


    this.accommodation.RoomTypes = this.accommodationForm.value.RoomTypes;
    this.accommodation.cityId = this.accommodationForm.value.cityId;
    const arr = [];

    if (this.accommodationForm.value.facilities) {
      this.accommodationForm.controls['facilities'].value.map(val => {
        arr.push(val.name);
      });
    }

    this.accommodation.facilities = arr;
    this.accommodationForm.value.RoomTypes.forEach(element => {
      if (element.id == null) { delete element.id; }
    });
  }

  fillFormData(data) {
    const included = [];
    this.accommodationForm.controls.name.setValue(data.name);
    this.accommodationForm.controls.badge.setValue(data.badge);
    this.accommodationForm.controls.description.setValue(data.description);
    this.accommodationForm.controls.type.setValue(data.type);
    this.accommodationForm.controls.cityId.setValue(data.cityId);
    this.accommodationForm.controls.localId.setValue(data.localId);
    this.accommodationForm.controls.AccommodationPictures.setValue(data.AccommodationPictures);

    data.included.map(a => {
      included.push(JSON.parse(a));
    });
    this.accommodationForm.controls.included.setValue(included);

    if (data.facilities.length > 0) {
      this.accommodationForm.controls.facilities.setValue(
        data.facilities.map(e => {
          return {
            id: e,
            name: e,
          }
        })
      );
      this.accommodationForm.controls.childrenPolicy.setValue(data.childrenPolicy);
    }

    data.RoomTypes.forEach(element => {
      (this.accommodationForm.get('RoomTypes') as DVFormArray).push(
        new DVFormGroup({
          id: new DVFormControl(element.id),
          capacity: new DVFormControl(element.capacity, {
            'Capacity is required': Validators.required
          }),
          name: new DVFormControl(element.name, {
            'Name is required': Validators.required
          }),
          pricePerPerson: new DVFormControl(element.pricePerPerson, {
            'Price Per Person is required': Validators.required
          })
        })
      );
    });

    this.accommodationForm.controls.Location.patchValue(
      data.Location
    );
    delete this.accommodationForm.value.Location.id;
  }

  loadAccommodation() {
    this.accommodationService.getAccommodation(this.currentId).subscribe(res => {
      this.fillFormData(res.data.accommodation);
    }, err => {
      console.log(err);
    });
  }

  editForm() {
    if (this.accommodationForm.invalid) {
      this.accommodationForm.forceShowErrors();
      return;
    }
    this.getFormData();

    this.accommodationService.editAccommodation(this.accommodation, +this.currentId).subscribe(res => {
      this.notifier.success('Accommodation Edited Successfully');
      this.router.navigateByUrl('/accommodations/list');
    },
      err => {
        this.notifier.error(err.error.error.details[0].message);
      });
  }

  cancel() {
    this.router.navigateByUrl('/accommodations/list');
  }

  //#region Country & City

  loadCities() {
    this.accommodationService.getAllCities(65).subscribe(res => {
      this.cities = [];
      this.cities = res.data.cities;
    });
  }
  loadLocals() {
    this.accommodationService.getAllLocals().subscribe(res => {
      this.locals = [];
      this.locals = res.data.locals;
    });
  }
  //#endregion

  //#region RoomTypes
  deleteRoomType(index) {
    (this.accommodationForm.controls.RoomTypes as DVFormArray).removeAt(index);
  }

  addNewRoomType() {
    (this.accommodationForm.controls.RoomTypes as DVFormArray).addChildrenToArray(
      this.generateRoomType()
    );
  }

  getFormArray(key): Array<any> {
    return (<DVFormArray>this.accommodationForm.controls[key]).controls;
  }

  private generateRoomType() {
    return new DVFormGroup({
      id: new DVFormControl(null),
      capacity: new DVFormControl(null, {
        'capacity is required': Validators.required
      }),
      name: new DVFormControl(null, {
        'name is required': Validators.required
      }),
      pricePerPerson: new DVFormControl(null, {
        'pricePerPerson is required': Validators.required
      })
    });
  }
  //#endregion

}

enum AccommodationType {
  Local = 'LOCAL',
  Hotel = 'HOTEL'
}
